import { faCalendarStar } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function KalenderTableEmpty() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-5">
      <FontAwesomeIcon
        icon={faCalendarStar}
        size="2x"
        className="text-neutrals-700"
      />
      <span className="text-sm text-neutrals-900">
        {t('domain.termine.kalender.table.empty')}
      </span>
      <span className="text-sm text-neutrals-700">
        {t('domain.termine.kalender.table.info')}
      </span>
    </div>
  );
}
